import { auth, db } from '../data/firebaseConfig.js';
import {
    signInWithEmailAndPassword,
    setPersistence,
    browserLocalPersistence,
    browserSessionPersistence,
    sendPasswordResetEmail
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

document.addEventListener('DOMContentLoaded', () => {
    const loginForm = document.getElementById('loginForm');
    const errorMessage = document.getElementById('errorMessage');
    const togglePassword = document.querySelector('.toggle-password');
    const passwordInput = document.getElementById('password');
    const rememberMe = document.getElementById('rememberMe');
    const forgotPasswordLink = document.getElementById('forgotPasswordLink');
    const resetPasswordModal = document.getElementById('resetPasswordModal');
    const resetPasswordForm = document.getElementById('resetPasswordForm');
    const resetMessage = document.getElementById('resetMessage');
    const closeModal = document.querySelector('.close-modal');

    // Verifica se há credenciais salvas
    const savedEmail = localStorage.getItem('rememberedEmail');
    const savedPassword = localStorage.getItem('rememberedPassword');

    if (savedEmail && savedPassword) {
        document.getElementById('email').value = savedEmail;
        document.getElementById('password').value = savedPassword;
        rememberMe.checked = true;
    }

    // Função para mostrar mensagem de erro
    const showError = (message, element = errorMessage) => {
        element.textContent = message;
        element.classList.add('show');
        setTimeout(() => {
            element.classList.remove('show');
        }, 5000);
    };

    // Função para mostrar mensagem de sucesso
    const showSuccess = (message, element = resetMessage) => {
        element.textContent = message;
        element.classList.add('success-message', 'show');
        setTimeout(() => {
            element.classList.remove('success-message', 'show');
        }, 5000);
    };

    // Função para validar email
    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    // Toggle password visibility
    if (togglePassword) {
        togglePassword.addEventListener('click', () => {
            const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
            passwordInput.setAttribute('type', type);
            togglePassword.classList.toggle('fa-eye');
            togglePassword.classList.toggle('fa-eye-slash');
        });
    }

    // Modal de recuperação de senha
    if (forgotPasswordLink) {
        forgotPasswordLink.addEventListener('click', (e) => {
            e.preventDefault();
            resetPasswordModal.classList.add('show');
        });
    }

    if (closeModal) {
        closeModal.addEventListener('click', () => {
            resetPasswordModal.classList.remove('show');
            resetPasswordForm.reset();
            resetMessage.textContent = '';
        });
    }

    // Fechar modal ao clicar fora
    window.addEventListener('click', (e) => {
        if (e.target === resetPasswordModal) {
            resetPasswordModal.classList.remove('show');
            resetPasswordForm.reset();
            resetMessage.textContent = '';
        }
    });

    // Formulário de recuperação de senha
    if (resetPasswordForm) {
        resetPasswordForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const email = document.getElementById('resetEmail').value;

            if (!isValidEmail(email)) {
                showError('Por favor, insira um email válido', resetMessage);
                return;
            }

            const submitButton = resetPasswordForm.querySelector('button[type="submit"]');
            submitButton.classList.add('loading');

            try {
                await sendPasswordResetEmail(auth, email);
                showSuccess('Email de recuperação enviado com sucesso!', resetMessage);
                resetPasswordForm.reset();
                setTimeout(() => {
                    resetPasswordModal.classList.remove('show');
                }, 3000);
            } catch (error) {
                console.error('Erro ao enviar email de recuperação:', error);
                let errorMsg = 'Erro ao enviar email de recuperação';

                switch (error.code) {
                    case 'auth/invalid-email':
                        errorMsg = 'Email inválido';
                        break;
                    case 'auth/user-not-found':
                        errorMsg = 'Nenhuma conta encontrada com este email';
                        break;
                    case 'auth/too-many-requests':
                        errorMsg = 'Muitas tentativas. Tente novamente mais tarde';
                        break;
                }

                showError(errorMsg, resetMessage);
            } finally {
                submitButton.classList.remove('loading');
            }
        });
    }

    // Formulário de login
    if (loginForm) {
        loginForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const email = document.getElementById('email').value;
            const password = document.getElementById('password').value;

            if (!isValidEmail(email)) {
                showError('Por favor, insira um email válido');
                return;
            }

            if (!password) {
                showError('Por favor, insira sua senha');
                return;
            }

            const submitButton = loginForm.querySelector('button[type="submit"]');
            submitButton.classList.add('loading');

            try {
                // Configura a persistência baseada na opção "Lembrar de mim"
                if (rememberMe.checked) {
                    await setPersistence(auth, browserLocalPersistence);
                    localStorage.setItem('rememberedEmail', email);
                    localStorage.setItem('rememberedPassword', password);
                } else {
                    await setPersistence(auth, browserSessionPersistence);
                    localStorage.removeItem('rememberedEmail');
                    localStorage.removeItem('rememberedPassword');
                }

                console.log('🔐 Tentando fazer login com:', email);
                
                // Faz login
                const userCredential = await signInWithEmailAndPassword(auth, email, password);
                console.log('✅ Login Firebase bem-sucedido. UID:', userCredential.user.uid);

                // Busca o tipo do usuário no Firestore
                console.log('📄 Buscando dados do usuário no Firestore...');
                const userDoc = await getDoc(doc(db, 'usuarios', userCredential.user.uid));
                
                console.log('📄 Documento existe?', userDoc.exists());
                
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    console.log('📄 Dados do usuário:', userData);
                    console.log('📄 Tipo do usuário:', userData.tipo);
                }

                // Verifica se o documento existe e se o usuário é do tipo responsável
                if (!userDoc.exists()) {
                    console.warn('⚠️ Usuário não encontrado no Firestore');
                    await auth.signOut();
                    loginForm.reset();
                    showError('Usuário não encontrado no sistema. Entre em contato com o administrador.');
                    submitButton.classList.remove('loading');
                    return;
                }

                const userData = userDoc.data();
                if (userData.tipo === 'responsável') {
                    console.warn('⚠️ Usuário do tipo "responsável" não autorizado');
                    await auth.signOut();
                    loginForm.reset();
                    showError('Usuário não autorizado');
                    submitButton.classList.remove('loading');
                    return;
                }

                // Verifica se o usuário está ativo
                if (userData.status && userData.status.toLowerCase() !== 'ativo') {
                    console.warn('⚠️ Usuário inativo');
                    await auth.signOut();
                    loginForm.reset();
                    showError('Usuário inativo. Entre em contato com o administrador.');
                    submitButton.classList.remove('loading');
                    return;
                }

                console.log('✅ Usuário autorizado. Redirecionando...');
                // Se chegou aqui, o usuário está autorizado
                window.location.href = '/src/pages/PaginaInicial.html';
            } catch (error) {
                console.error('❌ Erro no login:', error);
                console.error('❌ Código do erro:', error.code);
                console.error('❌ Mensagem do erro:', error.message);
                let errorMsg = 'Email ou senha incorretos';

                switch (error.code) {
                    case 'auth/invalid-email':
                        errorMsg = 'Email inválido';
                        break;
                    case 'auth/user-disabled':
                        errorMsg = 'Usuário desativado';
                        break;
                    case 'auth/user-not-found':
                        errorMsg = 'Usuário não encontrado';
                        break;
                    case 'auth/wrong-password':
                        errorMsg = 'Senha incorreta';
                        break;
                    case 'auth/invalid-credential':
                        errorMsg = 'Email ou senha incorretos';
                        break;
                    case 'auth/too-many-requests':
                        errorMsg = 'Muitas tentativas. Tente novamente mais tarde';
                        break;
                    case 'permission-denied':
                        errorMsg = 'Erro de permissão. Verifique as regras do Firestore.';
                        break;
                    default:
                        errorMsg = `Erro: ${error.message || error.code || 'Erro desconhecido'}`;
                }

                showError(errorMsg);
            } finally {
                submitButton.classList.remove('loading');
            }
        });
    }
}); 